var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDesktop && _vm.show)?_c('div',{class:{ weather: _vm.show, 'no-border': !_vm.bordered }},[(_vm.loading)?_c('Placeholder'):_c('div',{staticClass:"weather__temperature"},[_c('p',{staticClass:"title is-4"},[_vm._v(_vm._s(_vm.temperature))]),_c('p',{staticClass:"subtitle is-7 is-regular is-ellipsis"},[_vm._v(_vm._s(_vm.city))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }